// extracted by mini-css-extract-plugin
module.exports = {"Button":"_1s_XW4VtehwwFUiEa4oQvn","error":"_34WCyP3DDzMDfmlwTvcBlv","success":"_3QY4OdSPk8fhhmqK2g1BfL","primary":"cKT6BxyFc0xXiUH2MPH_d"};